<div class="ring">
  <div class="spinner"></div>
</div>
